import Banner from './Banner';
import Boxes from './Boxes';
import HowWeDoIt from './HowWeDoIt';
import Intro from './Intro';
import LearnMore from './LearnMore';

export { Banner, Boxes, HowWeDoIt, Intro, LearnMore };
